import { computed, reactive } from 'vue'
import { useToast } from 'primevue/usetoast'

interface Notification {
  severity: string
  summary: string
  detail: string
  life: number
  timestamp: string
}

const state = reactive({
  notifications: [] as Notification[],
})

export default function useNotifications() {
  const t = useToast()

  const notifications = computed(() => state.notifications)

  const toast = (message: string, detail: string, severity = 'success', life = 4000) => {
    const notif = {
      severity: severity,
      summary: message,
      detail: detail,
      life: life,
      timestamp: new Date().toISOString(),
    }
    t.add(notif)
    addNotification(notif)
  }

  const addNotification = (notif: Notification) => {
    state.notifications.unshift(notif)
  }

  const clearNotifications = () => {
    state.notifications = []
  }

  return {
    toast,
    notifications,
    clearNotifications,
  }
}
